function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.70762 4.48044V1.19403C8.70762 0.770113 9.20204 0.538535 9.52771 0.809919L15.7107 5.96236C15.9506 6.16226 15.9506 6.53069 15.7107 6.73059L9.52771 11.8832C9.20205 12.1545 8.70762 11.923 8.70762 11.499V8.21246L1.86572 8.21246C0.835152 8.21246 -0.00028801 7.37702 -0.00028801 6.34645C-0.00028801 5.31588 0.835153 4.48044 1.86572 4.48044L8.70762 4.48044Z",
  fill: "#828282"
});

const SvgIcForwardThick = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcForwardThick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-forward-thick.7093c1bb.svg";
export { ForwardRef as ReactComponent };